import { Input } from 'reactstrap';
import styled from 'styled-components';
import variaveis from '../../styles/variaveis.scss';

export const InputStyle = styled(Input)`
	&& {
		border-color: ${props => (props.error ? variaveis.red : 'none')};
		position: ${props => (props.type === 'checkbox' ? 'inherit' : null)};
		margin-left: ${props => (props.type === 'checkbox' ? '0.5rem' : null)};
		margin-right: ${props => (props.type === 'checkbox' ? '0.5rem' : null)};
		min-height: ${props => (props.type === 'textarea' ? '4.7em' : null)};
	}
	&:focus {
		color:  ${variaveis.selectHover};
		background-color: hsl(0,0%,100%);
		border-color: ${variaveis.selectHover}!important;
		box-shadow:  none!important;
		outline: 0;
		border-radius: 4px;
		border-style: solid;
		border-width: 1px;
	}

	&:active {
		border-color: ${variaveis.selectHover}!important;
		box-shadow:  ${variaveis.selectHover}!important;
	}

	&:hover {
		border-color: ${variaveis.selectHover};
	}
`;
